import { useLocation } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { HOME } from "@/constants/testIds";
import { BRAND_NAME, NAV, SPOTIFY_URL } from "@/lib/constants";

const slug = (label) => label.replace(/\s+/g, "-");

export const Header = () => {
    const { pathname } = useLocation();
    const isHome = pathname === "/";

    // On homepage, use anchor links directly; on sub-pages, prefix with / so
    // the browser navigates to the homepage first then scrolls to the anchor.
    const resolveHref = (href) => (isHome ? href : `/${href}`);
    const logoHref = isHome ? "#top" : "/";

    return (
    <header
        data-testid={HOME.header}
        className="sticky top-0 z-[70] bg-[var(--cream)] border-b border-[var(--rule)]"
    >
        <div className="mx-auto max-w-[1240px] px-6 sm:px-10 lg:px-16">
            <div className="flex h-[68px] items-center justify-between gap-6">
                <a
                    href={logoHref}
                    data-testid={HOME.headerLogo}
                    className="flex items-center gap-3 shrink-0"
                    aria-label="deep end grooves home"
                >
                    <Logo size={38} />
                    <span className="font-display text-sm sm:text-base">{BRAND_NAME}</span>
                </a>

                <nav aria-label="primary navigation" className="hidden lg:flex items-center gap-9">
                    {NAV.map((item) => (
                        <a
                            key={item.href}
                            href={resolveHref(item.href)}
                            data-testid={HOME.headerNavLink(slug(item.label))}
                            className="eyebrow text-[var(--ink)] hover:text-[var(--terracotta-ink)] transition-colors duration-200"
                        >
                            {item.label}
                        </a>
                    ))}
                </nav>

                <a
                    href={SPOTIFY_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid={HOME.headerSpotifyCta}
                    className="eyebrow shrink-0 border border-[var(--ink)] bg-[var(--ink)] px-4 py-2.5 text-[var(--cream)] hover:bg-[var(--terracotta-ink)] hover:border-[var(--terracotta-ink)] transition-colors duration-200"
                >
                    follow on spotify
                </a>
            </div>
        </div>

        <nav
            aria-label="mobile navigation"
            className="lg:hidden border-t border-[var(--rule)] overflow-x-auto"
        >
            <div className="mx-auto max-w-[1240px] flex items-center justify-between gap-4 px-6 sm:px-10 py-3 whitespace-nowrap">
                {NAV.map((item) => (
                    <a
                        key={`m-${item.href}`}
                        href={resolveHref(item.href)}
                        data-testid={`mobile-nav-${slug(item.label)}`}
                        className="eyebrow text-[var(--ink)] hover:text-[var(--terracotta-ink)] transition-colors duration-200"
                    >
                        <span className="sm:hidden">{item.short}</span>
                        <span className="hidden sm:inline">{item.label}</span>
                    </a>
                ))}
            </div>
        </nav>
    </header>
    );
};
